import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import * as MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import * as mapboxgl from 'mapbox-gl';
import { env } from '../../environments/environment';

@Component({
  selector: 'app-mapbox',
  templateUrl: './mapbox.component.html',
  styleUrls: ['./mapbox.component.scss'],
})
export class MapboxComponent implements OnInit, OnDestroy {
  get isSatellite() {
    return this._isSatellite;
  }
  set isSatellite(x) {
    this._isSatellite = x;
    this.style = x ? 'satellite-streets-v12' : 'streets-v11';
    this.setStyle();
  }

  map: mapboxgl.Map;
  style = 'satellite-streets-v12';

  geocoder: MapboxGeocoder;
  geocoderCache = {} as { [key: string]: any };

  @Input() lat = 37.75;
  @Input() lng = -122.41;
  @Input() minZoom = undefined;
  @Input() maxZoom = undefined;
  @Input() maxBounds = undefined;
  @Input() showFlagScoreContainer = false;
  @Output() load = new EventEmitter<MapboxComponent>();
  @Output() styleLoaded = new EventEmitter<void>();
  @Output() result = new EventEmitter<[number, number]>();
  @Output() scoreCheckerChanged = new EventEmitter<any>();

  markers: mapboxgl.Marker[] = [];
  _isSatellite = true;
  lastSearch;
  score0 = true;
  score1 = true;
  score2 = true;
  score3 = true;

  setStyle() {
    this.map.setStyle(`mapbox://styles/mapbox/${this.style}`);
  }

  constructor(private el: ElementRef) {}

  ngOnInit() {
    (mapboxgl as any).accessToken = env.mapbox;

    const container = this.el.nativeElement.querySelector('#map');
    this.map = new mapboxgl.Map({
      container,
      style: `mapbox://styles/mapbox/${this.style}`,
      zoom: 14,
      minZoom: this.minZoom,
      maxZoom: this.maxZoom,
      maxBounds: this.maxBounds,
      center: [this.lng, this.lat],
      accessToken: mapboxgl.accessToken,
    });

    this.geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      flyTo: false,
      mapboxgl: mapboxgl,
    });

    this.geocoder.on('result', r => {
      this.geocoderCache[this.lastSearch] = r.result.center;
      this.result.emit(r.result.center);
    });

    const geocoderDiv = this.el.nativeElement.querySelector('#hidden-geocoder');
    this.geocoder.addTo(geocoderDiv);

    // Add map controls
    // this.map.addControl(geocoder);
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.on('styledata', () => this.styleLoaded.emit());
    this.load.emit(this);
  }

  ngOnDestroy() {
    this.map.remove();
  }

  scoreChanged() {
    this.scoreCheckerChanged.emit({
      score0: this.score0,
      score1: this.score1,
      score2: this.score2,
      score3: this.score3,
    });
  }

  addMarker(marker: mapboxgl.Marker) {
    if (this.map) {
      this.markers.push(marker);
      marker.addTo(this.map);
    } else {
      console.error('Map not loaded yet!');
    }
  }

  jumpTo(options: mapboxgl.CameraOptions, eventData?: mapboxgl.EventData) {
    this.map.jumpTo(options, eventData);
  }

  removeMarkers() {
    while (this.markers.length) {
      this.markers.pop().remove();
    }
  }

  query(search: string) {
    if (search in this.geocoderCache) {
      this.result.emit(this.geocoderCache[search]);
      return;
    }
    this.lastSearch = search;
    this.geocoder.query(search);
  }
}
